import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameDynamicBlocksModule } from '@games/shared/game-dynamic-blocks/game-dynamic-blocks.module';
import { provideDynamicOrchestrator } from '@games/shared/orchestrator';
import { SpeedreadingHeaderOrchestrator } from './speedreading-header-orchestrator';
import { TranslateModule } from '@ngx-translate/core';

type SpeedreadingTheme = 'white' | 'black' | 'yellow';

type SpeedreadingOrientation = 'book' | 'album';

interface SpeedreadingConfig {
  theme: SpeedreadingTheme;
  orientation: SpeedreadingOrientation;
}

@Component({
    selector: 'ms-speedreading-header',
    imports: [CommonModule, TranslateModule, GameDynamicBlocksModule],
    templateUrl: './speedreading-header.component.html',
    styleUrls: ['./speedreading-header.component.scss'],
    providers: [
        provideDynamicOrchestrator(SpeedreadingHeaderOrchestrator),
    ]
})
export class SpeedreadingHeaderComponent {
  @Input() showTheme: boolean = true;

  @Input() showOrientation: boolean = true;

  @Input() showTimer: boolean = false;

  @Input() timer: number = 0;

  @HostBinding('class')
    theme: SpeedreadingTheme = 'white';

  readonly themes: SpeedreadingTheme[] = ['white', 'black', 'yellow'];

  orientation: SpeedreadingOrientation = 'album';

  readonly orientations: SpeedreadingOrientation[] = ['book', 'album'];

  @Output() readonly configChanges = new EventEmitter<SpeedreadingConfig>();

  constructor() {}

  ngOnInit() {
    this.emitChanges();
  }

  changeTheme() {
    this.theme = this.themes[(this.themes.indexOf(this.theme) + 1) % this.themes.length];
    this.emitChanges();
  }

  changeOrientation() {
    this.orientation =
      this.orientations[
        (this.orientations.indexOf(this.orientation) + 1) % this.orientations.length
      ];
    this.emitChanges();
  }

  emitChanges() {
    this.configChanges.next({
      theme: this.theme,
      orientation: this.orientation,
    });
  }
}
